import axios from 'axios'
// import Api from '@/services/Api'
/* eslint-disable */
export default {
    login(user) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/agent/login`,user)
    },
    disIndex() {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/agent/getAllDisabled`)
    }
    ,
    post(user) {

        // let params = JSON.stringify(body)
        // console.log(params);

        // let params = {
        //     "username": "axioss",
        //     "passowrd": "wuasaraarar",
        //     "name": "erfaan",
        //   }
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/agent/insert`, JSON.stringify(user), {
            headers: {
                'Content-Type': 'application/json'
            }
        })
    },

    // ,
    // put(visitrequest) {
    //     return Api().put('', )
    // },
    delete(userid) {
        return axios.post(`${'https://cors-anywhere.herokuapp.com/'}http://web.ahoorasystem.ir/api/agent/delete`,null, {
            params: {
                id: userid
            }
        })
    }
}